<template>
    <div
        class="LayoutDemo"
    >
        <router-view
            v-model="checked"
            page-header="Sample Header"
            :breadcrumbs="breadcrumbs"
            header="Test - Test"
            :allow-multiselect="false"
            sidebar-header="Sidebar Header"
            :headers="headers"
            :hide-id="false"
            :table-data="tableData"
            :sort="sort"
            :sort-direction="sortDirection"
            :tabs="settingsTabs"
            :active-tab="'Profiles'"
            compressed-field="name"
            :status="''"
            :show-sidebar="true"
            :user-profile="profile"
            :sections="sections"
            :active-section="activeSection"
            :subsections="subsections"
            :active-subsection="activeSubsection"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            profile: {
                "first_name": "Company",
                "email": "company@reviewpush.com",
                "profile_image": false,
                "role_name": "Master Admin",
            },
            headers: [
                {
                    label: "ID",
                    key: "id",
                },
                {
                    label: "Name",
                    key: "name",
                },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Role",
                    key: "role",
                },
            ],
            tableData: [
                {
                    id: 1,
                    name: "Test One",
                    email: "testOne@test.com",
                    role: "Test User",
                    // status: 'success'
                },
                {
                    id: 2,
                    name: "Test Two",
                    email: "testTwo@test.com",
                    role: "Test User",
                    // status: 'warning'
                },
                {
                    id: 3,
                    name: "Test Three",
                    email: "testThree@test.com",
                    role: "Test User",
                    // status: 'error'
                }
            ],
            sort: '',
            sortDirection: 'asc',
            checked: '',
            checkedTwo: [],
            "sections": [
                {
                    "key": "dashboard",
                    "label": "Dashboard",
                    "icon": "home",
                    "to": {
                        "name": "Dashboard"
                    }
                },
                {
                    "key": "locations",
                    "label": "Locations",
                    "icon": "locations",
                    "to": {
                        "name": "CompanyLocationsTable"
                    }
                },
                {
                    "key": "measure",
                    "label": "Measure",
                    "icon": "measure",
                    "to": {
                        "name": "OverviewReport"
                    }
                },
                {
                    "key": "request",
                    "label": "Request",
                    "icon": "request",
                    "to": {
                        "name": "CampaignsTable"
                    }
                },
                {
                    "key": "respond",
                    "label": "Respond",
                    "icon": "respond",
                    "to": {
                        "name": "ResponseFeed"
                    }
                },
                {
                    "key": "settings",
                    "label": "Settings",
                    "icon": "settings",
                    "to": {
                        "name": "UserNotificationsSettings"
                    }
                }
            ],
            "activeSection": {
                "key": "respond",
                "label": "Respond",
                "icon": "respond",
                "to": {
                    "name": "ResponseFeed"
                }
            },
            "subsections": [],
            "activeSubsection": {},
            breadcrumbs: [
                {
                    to: {name: ''},
                    label: 'Competitor Locations',
                },
                {
                    label: 'Applebee\'s',
                },
            ],
            settingsTabs: [
                {
                    to: {name: 'CompetitorAssociatedLocations'},
                    label: 'Associated Locations',
                },
                {
                    to: {name: 'CompetitorProfiles'},
                    label: 'Profiles',
                },
                {
                    to: {name: 'CompetitorGeneralSettings'},
                    label: 'General Settings',
                },
            ],
        };
    },
};
</script>
<style lang="scss">
    .LayoutDemo {
        height: 100%;
        width: 100%;
        background: $grey-50;
    }
</style>
